"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Component = void 0;
var Preact = __importStar(require("preact"));
var Box_1 = __importDefault(require("@mui/system/Box"));
var Typography_1 = __importDefault(require("@mui/material/Typography"));
/** Represents paragraph with heading and icon, usually used for reporting errors */
var Component = function (p) {
    return (Preact.h(Box_1.default, { maxWidth: "361px", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "flex-start" },
        Preact.h(Box_1.default, { paddingBottom: "27px" },
            Preact.h(p.Icon, { color: "primary" })),
        Preact.h(Box_1.default, { paddingBottom: "16px" },
            Preact.h(Typography_1.default, { variant: "h6" },
                p.heading,
                " ")),
        Preact.h(Typography_1.default, { variant: "body1", align: "center" }, p.paragraph)));
};
exports.Component = Component;
